import React from 'react'
import { Helmet } from 'react-helmet'

export default function Wishlist() {

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Wishlist' />
                <title>FreshCart | Wishlist</title>
            </Helmet>
            <div>Wishlist</div>
        </>
    )
}
